import React from 'react';
import classnames from 'classnames';
import { Typography, Button, formatDate } from '@guildeducationinc/recess';
import EditOutlinedIcon from '@guildeducationinc/recess/icons/EditOutlinedIcon';
import { clickable } from '@src/analytics';
import { DirtyProgramCompletion } from '@src/components/Pages/EditProfile/ProgramCompletion/ProgramCompletion';

interface InProgressProgramProps {
  handleEdit: () => void;
  programData: DirtyProgramCompletion;
}

export const EDIT_BUTTON_TEXT = 'Edit record';
export const EXPECTED_DATE_TEXT = 'Expected completion date: ';

const editRecordClickable = () => {
  clickable({
    loggedIn: true,
    product: 'account',
    tag: 'account_profile',
    text: 'edit_record',
    type: 'button',
  });
};

export const InProgressProgram: React.FC<InProgressProgramProps> = ({
  handleEdit,
  programData,
}) => {
  const containerClassNames = classnames([
    'padding--24',
    'margin--bottom_24',
    'borderWidth--1',
    'borderColor--black-lighten-70',
    'flex',
    'flexDirection--column',
    'lg:flexDirection--row',
    'lg:flexJustify--space_between',
  ]);

  const buttonClassNames = classnames([
    'margin--top_24',
    'lg:margin--top_0',
    'flexSelf--center',
    'lg:flexSelf--start',
    'flex--none',
  ]);

  const { academicPartnerName, programName, expectedGraduationDate } = programData;
  const PROGRAM_DESCRIPTION_TEXT = `${academicPartnerName} - ${programName}`;

  return (
    <div className={containerClassNames}>
      <div>
        <Typography variant='body2'>{PROGRAM_DESCRIPTION_TEXT}</Typography>
        <span className='fontWeight--700 lineHeight--24'>{EXPECTED_DATE_TEXT}</span>
        <span>{formatDate(expectedGraduationDate, 'MM/dd/yyyy')}</span>
      </div>

      <Button
        appearance='ghost'
        className={buttonClassNames}
        iconDirection='left'
        icon={<EditOutlinedIcon size={24} />}
        onClick={() => {
          handleEdit();
          editRecordClickable();
        }}
      >
        {EDIT_BUTTON_TEXT}
      </Button>
    </div>
  );
};
